import axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import StyledButton from "../../components/basicsComponents/StyledButton/StyledButton";
import ModalPacienteForm from "../../components/formComponents/ModalFormPaciente/ModalFormPaciente";
import CustomToast from "../../components/basicsComponents/CustomToast/CustomToast.jsx";
import LoadingBackdrop from "../../components/basicsComponents/LoadingBackdrop/LoadingBackdrop";
import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Link,
  Typography,
} from "@mui/joy";
import CustomInput from "../../components/basicsComponents/CustomInput/CustomInput";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import useTituloPagina from "../../hooks/tituloPagina";
import "./login.css";

const LoginIonic = () => {
  const [cargando, setCargando] = useState(false);
  const [blnVerPassword, setBlnVerPassword] = useState(false);
  const [usuario, setUsuario] = useState({
    usuario: "",
    password: "",
    token: "",
  });
  const [urlAxioPP, setUrlAxio] = useState("");
  const [tituloPagina, setTituloPagina] = useState("");
  const [errorUsuario, setErrorUsuario] = useState(false);
  const [errorPassword, setErrorPassword] = useState(false);
  const [msjErrorPassword, setMsjErrorPassword] = useState("");
  const [registrarPaciente, setRegistrarPaciente] = useState(false);
  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });
  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };

  const history = useHistory();
  useTituloPagina();

  const handleChangeVisibilityOfPassword = () => {
    setBlnVerPassword(!blnVerPassword);
  };

  useEffect(() => {
    setUrlAxio(localStorage.getItem("urlAxioPP"));
    setTituloPagina(localStorage.getItem("nombreClinica"));

    document.title = localStorage.getItem("tituloWeb");
    sessionStorage.removeItem("ppUL");
  }, []);

  const loginPaciente = async (usuario, password) => {
    try {
      const response = await axios.post(`${urlAxioPP}Usuarios/LoginPaciente`, {
        nombreUsuario: usuario,
        password: password,
      });
      return response.data.token;
    } catch (error) {
      setErrorPassword(true);
      setMsjErrorPassword("Documento o contraseña incorrecto");
      mostrarNotificacion(true, "Error: " + error.response.data, "rojo");
    }
  };

  const obtenerPaciente = async (token, documento) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };
      const response = await axios.get(
        `${urlAxioPP}Pacientes?documento=${documento}`,
        config
      );
      const data = response.data[0];
      return {
        usuario: usuario.usuario,
        password: usuario.password,
        token: token,
        codigo: data.codigo,
        hc: data.hc,
        documentoNro: data.documentoNro,
        documentoTipo: data.documentoTipo,
        documentoTipoNombre: data.documentoTipoNombre,
        nombre: data.nombre,
        apellido: data.apellido,
        mutual: data.mutual,
        mutualNombre: data.mutualNombre,
        telefono: data.telefono,
        celular: data.celular,
        email: data.email,
        mutualAfiliado: data.mutualAfiliado,
        nacimiento: data.nacimiento,
      };
    } catch (error) {
      console.error("Error en petición obtenerPaciente", error.response);
      mostrarNotificacion(
        true,
        "Error al consultar los datos del paciente. Verifique si el usuario y contraseña están registrados.",
        "rojo"
      );
    }
  };

  const handleClickLogin = async () => {
    setCargando(true);
    if (usuario.usuario !== "" && usuario.password !== "") {
      const token = await loginPaciente(usuario.usuario, usuario.password);
      const paciente = await obtenerPaciente(token, usuario.usuario);
      if (paciente) {
        mostrarNotificacion(true, "Sesión iniciada correctamente", "verde");
        setUsuario(paciente);
        sessionStorage.setItem("ppUL", JSON.stringify(paciente));
        history.push("/portal/Inicio", { justLogin: true });
      }
    } else {
      if (usuario.usuario !== "") setErrorUsuario(true);
      if (usuario.password !== "") {
        setErrorPassword(true);
        setMsjErrorPassword("Debe ingresar su contraseña");
      }
    }
    setCargando(false);
  };

  const handleClickSubmit = () => {
    setCargando(true);
    handleClickLogin();
    setCargando(false);
  };

  const handleChangeUsuario = (e) => {
    const value = e.target.value;
    //Reemplazamos los valores no numericos por espacios en blanco
    const filteredValue = value.replace(/[^0-9]+/g, "");
    setErrorUsuario(false);
    setUsuario({ usuario: filteredValue, password: usuario.password });
  };

  const handleChangePassword = (e) => {
    const value = e.target.value;
    //Reemplazamos los valores no numericos por espacios en blanco
    const filteredValue = value.replace(/[^0-9]+/g, "");
    setErrorPassword(false);
    setUsuario({ usuario: usuario.usuario, password: filteredValue });
  };

  const handleClickCopiarTelefono = () => {
    const phoneNumber = "0810-555-2765";
    navigator.clipboard.writeText(phoneNumber);

    mostrarNotificacion(
      true,
      "Se ha copiado el numero de telefono a su portapapeles",
      ""
    );
  };

  return (
    <Box className="login-page">
      <Box className="login-main">
        <Card className="login-card">
          <CardContent>
            <Box className="login-content">
              <Box className="login-logo">
                <img
                  alt="Logo clinica"
                  src="assets/onnis1.png"
                  style={{ width: "150px", height: "auto" }}
                />
              </Box>
              <Typography level="title-lg" align="center">
                {"Portal del paciente".toUpperCase()}
              </Typography>
              <form className="login-form" noValidate autoComplete="off">
                <CustomInput
                  fullWidth
                  margin="normal"
                  value={usuario.usuario}
                  onChange={handleChangeUsuario}
                  error={errorUsuario}
                  startDecorator={
                    <Typography
                      variant="plain"
                      color="neutral"
                      sx={{ width: "100px" }}
                    >
                      Documento:
                    </Typography>
                  }
                />
                <CustomInput
                  fullWidth
                  margin="normal"
                  startDecorator={
                    <Typography
                      variant="plain"
                      color="neutral"
                      sx={{ width: "100px" }}
                    >
                      Contraseña:
                    </Typography>
                  }
                  endDecorator={
                    <React.Fragment>
                      <Divider orientation="vertical" />
                      <Button
                        onClick={handleChangeVisibilityOfPassword}
                        type="button"
                        variant="plain"
                        color="neutral"
                      >
                        {blnVerPassword ? <Visibility /> : <VisibilityOff />}
                      </Button>
                    </React.Fragment>
                  }
                  type={blnVerPassword ? "text" : "password"}
                  value={usuario.password}
                  onChange={handleChangePassword}
                  error={errorPassword}
                  helperText={
                    "Si no cambio su contraseña, ingrese su numero de documento"
                  }
                  errorHelperText={msjErrorPassword}
                />
                <Button
                  fullWidth
                  variant="solid"
                  type="button"
                  onClick={handleClickSubmit}
                  disabled={cargando}
                  value={"Ingresar"}
                  style={{
                    backgroundColor: "var(--my-custom-color)",
                    color: "white",
                    textTransform: "uppercase",
                  }}
                >
                  Ingresar
                </Button>
              </form>
              <Typography
                level="body-xs"
                paddingInline={1}
                className="login-registration-prompt"
              >
                {"¿ No está registrado. ?"}
              </Typography>

              <StyledButton
                className="verde login-registration-button"
                expand="block"
                fill="clear"
                onClick={handleClickCopiarTelefono}
                href={
                  "https://wa.me/3512613002?text=Hola,%20me%20pon%C3%ADa%20en%20contacto%20para%20registrarme.%20Dejo%20mis%20datos%20a%20continuaci%C3%B3n:%0ADNI%20(sin%20puntos/espacios):%0ANombre%20y%20apellido:%0AFecha%20de%20nacimiento:%0AEmail:%0ACelular:%0AObra%20social%20%E2%80%93%20plan:"
                }
                target="_blank"
              >
                <Typography
                  level="body-xs"
                  paddingInline={1}
                  style={{ justifyContent: "center", margin: "auto" }}
                >
                  {"Registrarse aquí"}
                </Typography>
              </StyledButton>
            </Box>
          </CardContent>
        </Card>
      </Box>
      <Link
        className="login-footer"
        href="https://www.gacitua.com.ar/"
        rel="Proveedor del servicio noreferrer"
        target="_blank"
      >
        <Typography level="title-lg">
          <Typography className="login-footer-label">
            {"Powered by "}
          </Typography>
          <img
            src={"assets/logoGacitua.png"}
            alt="logo gacitua y asociados"
            width={17}
            height={17}
          />
          <Typography> {" Gacitua & Asociados"}</Typography>
        </Typography>
      </Link>

      <ModalPacienteForm
        mostrarNotificacion={mostrarNotificacion}
        openModal={registrarPaciente}
        setOpenModal={setRegistrarPaciente}
      />

      <CustomToast
        openToast={toast.open}
        onDidDismiss={() => mostrarNotificacion(false, "", "")}
        message={toast.mensaje}
        colorNotificacion={toast.tipo}
      />

      {cargando && <LoadingBackdrop visualizar={cargando} />}
    </Box>
  );
};

export default LoginIonic;
